<template>
  <div>
    <div class="reservationHeader" v-if="!outHeader">
      <b v-text="(!info ? 'Estado: ' : '') + state" />
      <v-icon v-if="activeClick" class="float-right" color="white"
        >mdi-dots-horizontal</v-icon
      >
    </div>
    <div class="aroundSpace">
      <div class="font-weight-medium" v-for="item in data" :key="item.id">
        <v-icon left v-if="item.icon1" color="primary" v-text="item.icon1" />
        <span
          v-html="item.title"
          :class="info ? '' : 'text-decoration-underline'"
        />
        <div class="float-right">
          <v-icon left v-if="item.icon2" color="primary" v-text="item.icon2" />
          <span
            v-html="item.info"
            :class="
              info ? (mini ? 'colorGrey' : '') : 'text-decoration-underline'
            "
          />
        </div>
        <br v-if="!mini" />
        <br v-if="!mini" />
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  data: {
    default: [],
    type: Array,
  },
  state: {
    default: "Desconocido",
    type: String,
  },
  info: {
    default: false,
    type: Boolean,
  },
  mini: {
    default: false,
    type: Boolean,
  },
  outHeader: {
    default: false,
    type: Boolean,
  },
  icon1: {
    default: "",
    type: String,
  },
  icon2: {
    default: "",
    type: String,
  },
  activeClick: {
    default: true,
    type: Boolean,
  },
};

export default {
  components: {},
  methods: {},
  props: props,
};
</script>

<style scoped>
.aroundSpace {
  padding: 5%;
}
span {
  color: #005591;
}
.colorGrey {
  color: grey;
}
.reservationHeader {
  background-color: #005591;
  padding: 3px !important;
  color: white;
}
</style>
